import React from 'react';
import classes from './index.module.scss';
import ScheduleOptions from './ScheduleOptions';
import moment from 'moment';

const ScheduleBox = ({ type, messageInfo, handleDefaultStatusCodes, setLoading }) => {
  const { template_id, is_active, subject, last_triggered, recurrence_frequency, body, recurrence_interval, scheduled_send_time, template_title, created  } = messageInfo; // ?
  const date = moment(created).format('MM/DD/YYYY hh:mm A');
  const last_triggered_date = moment(last_triggered).format('MM/DD/YYYY hh:mm A');
  const scheduled_send_time_date = scheduled_send_time ? moment(scheduled_send_time).format('MM/DD/YYYY hh:mm A'): 'Never';
  const is_active_data = !!is_active;
  const selectValue={"ONE_TIME": "Onetime", "DAY": "Daily", "WEEK": "Weekly", "MONTH": "Monthly", "YEAR": "Yearly"}; 
  
  return (
    <div className={classes.Message_Box}>
      <div className={classes.Message_Header} style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div className={classes.Message_Sub_Header_Left} style={{padding: '0.2rem'}}>
            <h6>Template title: <b>{template_title}</b></h6>
        </div>
        <div className={classes.Message_Sub_Header_Right} style={{padding: '0.2rem'}}>
          <h6>Created date: {date}</h6>
          <span className={classes.Status}></span>
        </div>
        <div className={classes.Message_Sub_Header_Right} style={{padding: '0.2rem'}}>
          <span className={`${is_active_data ? "responded" : "not_responded"} general`}>
            {is_active_data ? "Active" : "Not Active"}
          </span>
        </div>
      </div>
      <div className={classes.Message_Sub_Header} style={{flexWrap: 'wrap' }}>
        <div className={classes.Message_Sub_Header_Left} style={{padding: '0.2rem'}}>
            <h6>Frequency: <b>{selectValue[recurrence_frequency]}</b></h6>
        </div>
        <div className={classes.Message_Sub_Header_Right} style={{padding: '0.2rem'}}>
          <h6>Interval: {recurrence_interval}</h6>
          <span className={classes.Status}></span>
        </div>
        <div className={classes.Message_Sub_Header_Right} style={{padding: '0.2rem'}}>
          <h6>Scheduled send time: {scheduled_send_time_date}</h6>
          <span className={classes.Status}></span>
        </div>
        <div className={classes.Message_Sub_Header_Right} style={{padding: '0.2rem'}}>
          <h6>Last Triggered: {last_triggered ? last_triggered_date : 'Never'}</h6>
          <span className={classes.Status}></span>
        </div>
      </div>
      {type === "email" ?
      <div className={classes.Message_Sub_Header} style={{flexWrap: 'wrap' }}>
        <div className={classes.Message_Sub_Header_Left} style={{padding: '0.2rem'}}>
            <h6>Subject: <b>{subject}</b></h6>
        </div>
      </div>
      : ''}
      <div className={classes.Message_Content}>
        <p className="mb-0" dangerouslySetInnerHTML={{ __html: body }}></p>
      </div>
        <ScheduleOptions 
          template_id={template_id}
          type={type}
          handleDefaultStatusCodes={handleDefaultStatusCodes}
          setLoading={setLoading}
        />
    </div>
  )
}

export default ScheduleBox;